<h2 mat-dialog-title>Select Profile</h2>
<mat-dialog-content>
  <mat-selection-list [(ngModel)]="selectedProfiles">
    <mat-list-option *ngFor="let profile of profiles" [value]="profile">
      {{ profile.name }}
    </mat-list-option>
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="addSelectedProfiles()">
    Add
  </button>
</mat-dialog-actions>
